import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { EnvioDocumentosServicoConfigResponse } from '../../responses/servico/envio-documentos-servico-config.response';
import { EnvioDocumentosServicoConfigRequest } from '../../requests/servico/envio-documentos-servico-config.request';

@Injectable({
  providedIn: 'root',
})
export class EnvioDocumentosServicoConfigService extends CommonService {
  private readonly apiUrl: string = environment.urlApiServico + 'EnvioDocumentosServicoConfig';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public get(): Observable<EnvioDocumentosServicoConfigResponse> {
    return this.httpClient
      .get<EnvioDocumentosServicoConfigResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public update(
    id: number,
    request: EnvioDocumentosServicoConfigRequest
  ): Observable<EnvioDocumentosServicoConfigResponse> {
    const url = `${this.apiUrl}/idEnvioDocumentosServicoConfig/${id}`;
    return this.httpClient
      .put<EnvioDocumentosServicoConfigResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
